import {  
  loadRemoteDeviceDataInProgress,
  loadRemoteDeviceDataSuccess,
  loadRemoteDeviceDataFailure,
  remoteDeviceOperationCompleted
} from "../state/remotedevice/actions";
import { oopsSweetAlert } from '../components/SweetAlertMessages';
import { errorSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
import swal from 'sweetalert';

const serverBasePath=process.env.REACT_APP_SERVER_API_URL;

export const loadRemoteDevice = (searchText='', page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadRemoteDeviceDataInProgress());
    const response = await fetch(serverBasePath+"/remote/device?searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
      {
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }});
      const data = await response.json();
      dispatch(remoteDeviceOperationCompleted()); 
      if(response.status !== 200){
        swal("Error", data?.error?.message, "error");
        return;
      }
      dispatch(loadRemoteDeviceDataSuccess(data));
  } catch (e) {       
    dispatch(loadRemoteDeviceDataFailure());
    errorSweetAlert(e);
  }
};

export const downloadSocketLogFile = (rowId,fileName,fileType) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadRemoteDeviceDataInProgress());
          const response = await fetch(serverBasePath+"/remote/"+rowId+"/"+fileType+"/download",
          {   
              method: "GET",
              headers: {
                  Authorization: 'Bearer ' + token,
              }
          });
          dispatch(remoteDeviceOperationCompleted()); 
          if(response.status === 500){
              const errorMessage = { error: { code: 'SERVER_ERROR', message: 'Internal Server Error' }};
              oopsSweetAlert(errorMessage);
              return
          }
          const blob = await response.blob();
          const url  = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href  = url;
          link.setAttribute('download',fileName); 
          document.body.appendChild(link);
          link.click();
          dispatch(remoteDeviceOperationCompleted()); 
      } catch (e) {   
          dispatch(loadRemoteDeviceDataFailure());
          errorSweetAlert(e); 
      }
  };
};
